import { Line, LineConfig } from '@ant-design/charts'
import React from 'react'

import { ColorKeys, Colors } from '@/constants/channel-colors'
import { ChannelDetail } from '@/model/analytics'
import { formatPrice } from '@/utils/formatter'

export interface ChannelDetailsChartProps {
  details: ChannelDetail[]
}

export default function ChannelDetailsChart({
  details,
}: ChannelDetailsChartProps) {
  const data = details.flatMap(item =>
    item.totalByChannelWithName.map(d => ({ ...d, dateStr: item.dateStr, detail: item })),
  )

  const config: LineConfig = {
    data,
    xField: 'dateStr',
    yField: 'earnings',
    seriesField: 'name',
    point: {
      zIndex: 2,
      style: {
        stroke: (d: { name: ColorKeys }) => Colors[d.name],
        fill: 'white',
        lineWidth: 1.5,
      },
    },
    line: {
      zIndex: 1,
      style: {
        stroke: (d: [{ name: ColorKeys }]) => Colors[d[0].name],
        lineWidth: 1.5,
      },
    },
    legend: false,
    axis: {
      x: {
        labelAutoRotate: false,
      },
    },
    height: 280,
    tooltip: {
      items: [
        (d: (typeof data)[number]) => {
          return {
            color: Colors[d.name as ColorKeys],
            name: d.name,
            value: formatPrice()(d.earnings),
          }
        }],
    },
  }

  return <Line {...config} />
}
